export const EVENTS = {
    SPOT_TV_VIEW_CHANGED: 'spot-tv-view-changed'
};
